import Alert from "@mui/material/Alert";
import { useDictionary } from "hooks/use-dictionary";
import { ReactElement } from "react";

interface FiltersAlertProps<T> {
  filters: T;
  formatters: { [key in keyof T]?: (val: T[key]) => string | ReactElement };
}

const FiltersAlert = <T,>({ filters, formatters }: FiltersAlertProps<T>) => {
  const dict = useDictionary();
  const goodFilters = Object.entries(filters ?? {}).filter(([key, value]) => {
    return value != null && value !== "" && !(Array.isArray(value) && value.length === 0);
  });

  const formattedFilters = goodFilters
    .map(([key, value]) => {
      const formattedValue = formatters[key as keyof T]
        ? formatters[key as keyof T]?.(value as T[keyof T])
        : `${key as string} (${value})`;
      return formattedValue ? { key, formattedValue } : null;
    })
    .filter(Boolean);

  return !formattedFilters.length ? null : (
    <Alert severity="info" variant="outlined">
      <div className="flex flex-wrap">
        <span className="mr-1">{dict.common.filterAlert.label}:</span>
        {formattedFilters.map(
          (x, i) =>
            x && (
              <div key={`filter-${String(x.key)}-${i}`} className="flex">
                <span style={{ whiteSpace: "nowrap" }}>
                  {x.formattedValue}
                  {i < formattedFilters.length - 1 && <span>,&nbsp;</span>}
                </span>
              </div>
            )
        )}
      </div>
    </Alert>
  );
};

export default FiltersAlert;
